module.exports = __webpack_public_path__ + "static/img/btn_gfcz.5fa44c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/btn_gfcz.png
// module id = KLXi
// module chunks = 7